import type { ResolvedDependency } from '@wix/ambassador-app-service-webapp/types';
import type { MarketListing } from '@wix/ambassador-devcenter-app-market-listing-v1-market-listing/types';
import type { GetAppResponse } from '@wix/ambassador-devcenter-apps-v1-app/types';
import { HttpClient } from '@wix/http-client';
import { getAppDependencies } from './appDependencies';
import {
  GetAppMarketListingParams,
  fetchAppsNames,
  getAllAppMarketListings,
  getAppsInfoByLanguageWithDefaults,
} from './appMarketListings';
import { fetchAppInfo } from './devCenterApps';

class AppMarketService {
  constructor(private httpClient: HttpClient) {}

  public getAllAppMarketListings(
    params: GetAppMarketListingParams,
  ): Promise<MarketListing[]> {
    return getAllAppMarketListings(this.httpClient, params);
  }

  public getAppsInfoByLanguageWithDefaults(
    params: GetAppMarketListingParams,
  ): Promise<Record<string, MarketListing>> {
    return getAppsInfoByLanguageWithDefaults(
      this.httpClient,
      params.appDefinitionIds,
      params.languageCode || 'en',
    );
  }

  public fetchAppsNames(
    appDefIds: string[],
    languageCode?: string,
  ): Promise<Record<string, string>> {
    return fetchAppsNames(this.httpClient, appDefIds, languageCode);
  }

  public getAppDependencies(
    appId: string,
    appVersion?: string,
  ): Promise<ResolvedDependency[]> {
    return getAppDependencies(appId, appVersion);
  }

  public fetchAppInfo(
    appId: string,
    version: string = 'latest',
  ): Promise<GetAppResponse | undefined> {
    return fetchAppInfo(this.httpClient, appId, version);
  }
}

const appMarketService = new AppMarketService(new HttpClient());

export { AppMarketService, appMarketService };
